import {CLEAR_MESSAGE, SET_MESSAGE} from './types';

export const ClearMessage = () => dispatch => {
  dispatch ({type: CLEAR_MESSAGE});
};
export const SetMessage = (type, msg) => dispatch => {
  dispatch ({type: SET_MESSAGE, payload: {type, msg}});
};
